import { cn } from "@/lib/utils";
import * as React from "react";

const sizeMap = { sm: 16, md: 24, lg: 36 } as const;

export interface SpinnerProps extends React.SVGProps<SVGSVGElement> {
  size?: keyof typeof sizeMap;
}

/**
 * A single hairline arc in `currentColor`. No thick rings, no brand colour —
 * consistent with the rest of the 1px vocabulary.
 */
const Spinner = ({ size = "md", className, ...props }: SpinnerProps) => {
  const px = sizeMap[size];
  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      role="status"
      aria-live="polite"
      className={cn("animate-spin text-kf-ink", className)}
      {...props}
    >
      <circle
        cx="12"
        cy="12"
        r="10.5"
        stroke="currentColor"
        strokeOpacity="0.15"
        strokeWidth="1"
      />
      <path
        d="M22.5 12A10.5 10.5 0 0 0 12 1.5"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="square"
      />
    </svg>
  );
};

export { Spinner };
